import { DialogTitle, Icon, IconButton, Typography } from '@material-ui/core'
import effects from 'app/effects/effects'
import { useFetcher } from 'libs/fetcher'
import moment from 'moment'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { PlanBillingSetPaymentMethodForm } from './PlanBillingSetPaymentMethodForm'
import { usePlanBillingContext } from '../usePlanBillingContext'

export const PlanBillingPaymentMethodFormDialog = (props) => {
  const { isOpen, onClose } = props
  const { refetch } = usePlanBillingContext()

  const handleClose = () => {
    refetch()
    onClose()
  }

  return (
    <ResponsiveDialog
      open={isOpen}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      fullWidth
      maxWidth="md"
      classes={{ paper: 'overflow-y-visible' }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="flex justify-between items-center">
          <Typography variant="h6">
            <FormattedMessage id="planAndBilling.yourPlan.changePlan.changePaymentMethod.label" />
          </Typography>
          <IconButton disableRipple onClick={handleClose}>
            <Icon>close</Icon>
          </IconButton>
        </div>
      </DialogTitle>

      <PaymentMethodFormContainer {...props} />
    </ResponsiveDialog>
  )
}

const PaymentMethodFormContainer = (props) => {
  const { onClose } = props
  const [fetchedAt, setFetchedAt] = useState()
  const fetchPaymentMethod = useCallback(() => {
    return effects.apis.getPaymentMethod()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedAt])

  const refetchPaymentMethods = () => {
    setFetchedAt(moment())
  }
  const { values: paymentMethods } = useFetcher(fetchPaymentMethod, {
    data: [],
  })

  return (
    <PlanBillingSetPaymentMethodForm
      refetchPaymentMethods={refetchPaymentMethods}
      onClose={onClose}
      paymentMethods={R.prop('data', paymentMethods)}
    />
  )
}

PlanBillingPaymentMethodFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
}
